(function () {
  'use strict';

  if (typeof IntersectionObserver === 'undefined') return;

  function initFadeUps() {
    const els = document.querySelectorAll('.c-fade-up');
    if (!els.length) return;

    const observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.12, rootMargin: '0px 0px -40px 0px' }
    );

    els.forEach(function (el) {
      observer.observe(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initFadeUps);
  } else {
    initFadeUps();
  }
})();
